export const GET_MY_CLUB = "GET_MY_CLUB";
export const SET_CLUB = "SET_CLUB";
export const GET_CLUB = "GET_CLUB";

export const GET_CLUB_BILLING = "GET_CLUB_BILLING";
export const SET_CLUB_BILLING = "SET_CLUB_BILLING";
